import { render, staticRenderFns } from "./ArtistDetail.vue?vue&type=template&id=247378eb&scoped=true&"
import script from "./ArtistDetail.vue?vue&type=script&lang=js&"
export * from "./ArtistDetail.vue?vue&type=script&lang=js&"
import style0 from "./ArtistDetail.vue?vue&type=style&index=0&id=247378eb&scoped=true&lang=css&"
import style1 from "./ArtistDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247378eb",
  null
  
)

component.options.__file = "ArtistDetail.vue"
export default component.exports